import { Component, OnInit } from '@angular/core';
import { RequestsService } from '../requests.service';
import { PropertiesService, PropertyPageEnum } from '../properties.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-request-logs',
  templateUrl: './request-logs.component.html',
  styleUrls: ['./request-logs.component.scss']
})
export class RequestLogsComponent implements OnInit {
  private intervalRef;
  private currentPage: string;

  constructor(private properties: PropertiesService, private requests: RequestsService, private router: Router) { 
    this.properties.currentMessage.subscribe((message: string) => {
      if (message === 'reload-icons') {
        this.queryRequestLogs();
      }
    })

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        console.log(`Navigation End Event Called ${val.url}`);
        this.currentPage = val.url;
      }
    });
  }

  ngOnDestroy () {
    clearInterval(this.intervalRef);
    this.intervalRef = null;
  }

  queryRequestLogs = () => {
    console.log(`Current Page is ${this.currentPage}`);
      if (this.properties.current && this.currentPage === '/request_logs') {
        this.requests.getRequests(this.properties.current.hostname).then(requests => console.log(`Loaded requests`));
        this.requests.getTotalRequests(this.properties.current.hostname).then(success => console.log('loaded total request counts'));
      }
  }

  ngOnInit() {
    this.queryRequestLogs();
    

    /* Start polling for changes */ 
    this.intervalRef = setInterval(() => {
      this.queryRequestLogs();
    }, 5000);
    
  }

}
